module.exports = __webpack_public_path__ + "static/media/Honorarios.ac3cc6b9.png";